import { render, staticRenderFns } from "./VOfferRowField.vue?vue&type=template&id=27c0b10b"
import script from "./VOfferRowField.vue?vue&type=script&lang=js"
export * from "./VOfferRowField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports